import { useQuery } from '@tanstack/react-query';
import { MAX_GLOBAL_AGGREGATE_THRESHOLD, RQ_USER_CONFIG } from 'Utils';
import i18next from 'i18next';
import { getUserConfig } from 'Services';
import type { UserConfig } from '@brighterion/types/config';

const configServiceDefault: UserConfig = {
    featureFlags: {},
    translations: {},
    tier2BankUsers: [],
    customListTypes: [],
    constants: {
        maxGlobalAggregateThreshold: MAX_GLOBAL_AGGREGATE_THRESHOLD,
        minGlobalScore: -100,
        maxGlobalScore: 100
    },
    tableauReports: []
};

const useUserConfig = (uniqueUserTokenId: string) => {
    return useQuery<UserConfig>([RQ_USER_CONFIG, uniqueUserTokenId], getUserConfig, {
        select: (data: UserConfig): UserConfig => {
            const translations: [string, any][] = data.translations ? Object.entries(data.translations) : [];
            translations?.forEach(([key, value]) => {
                i18next.addResourceBundle(key, 'translation', {
                    ...value
                });
            });

            return {
                ...configServiceDefault,
                ...data
            };
        }
    });
};

export default useUserConfig;
